import React from "react";
import { StreamPage, HomePage, SchedulePage, StandingsPage, NotFoundPage, PlayoffPage } from "./pages";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./styles/common.css"

function App() {
  return (

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/stream/:id" element={<StreamPage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/standings" element={<StandingsPage />} />
          <Route path="/playoffs" element={<PlayoffPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
